import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";
import { FactionEnum } from "@/domains/faction/constants/factionEnum";

/* APP state */
export interface AppState {
  faction: FactionEnum;
}

/* STATE */
export interface FactionState {
  app: AppState;
}

// ===================================================================

/* APP initial */
const initialApp: FactionState["app"] = {
  faction: FactionEnum.HOSPITAL,
};

/* STATE initial */
const initialState: FactionState = {
  app: initialApp,
};

// ===================================================================

const factionSlice = createSlice({
  name: "businessSlice",
  initialState,
  reducers: {
    /* STATE reducer */
    // clearSlice: (state, action?: PayloadAction) => {
    //   state.app = { ...initialApp };
    // },
    changeFaction: (state, action: PayloadAction<FactionEnum>) => {
      state.app.faction = action.payload;
    },
  },
});

/* APP selector */
export const factionSelector = (state: RootState) => state.faction.app.faction;

export const factionReducer = factionSlice.reducer;
export const { changeFaction } = factionSlice.actions;
